import styled from 'styled-components';

export const SectionTitle = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 55px;
  padding-top: 48px;
`;

export const Results = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 40px;
`;

export const SearchWord = styled.span`
  font-weight: 600;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  margin-bottom: 40px;
  margin-top: 35px;

  @media ${(props) => props.theme.device.tabletL} {
    padding: 0 20px;
  }
`;

export const SelectsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  @media (min-width: 1280px) {
    justify-content: unset;
  }
  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    flex-direction: column;
  }
`;

export const Filter = styled.div`
  min-width: 115px;
  width: fit-content;
`;

export const ResultContainer = styled.div`
  margin-top: 40px;
`;

export const CardsGrid = styled.div`
  padding-bottom: 4rem;
  display: grid;
  gap: 28px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media ${(props) => props.theme.device.laptop} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media ${(props) => props.theme.device.tabletL} {
    grid-template-columns: 1fr 1fr;
  }
  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 1fr;
  }
`;

export const TabsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  // Filter Tabs on two row and center alignment
  > div {
    max-width: 70%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    > div {
      margin-bottom: 10px;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    text-align: center;
  }
`;

export const TotalCount = styled.div`
  margin-bottom: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.brownGrey};
`;

export const TotalCountLabel = styled.span`
  font-style: italic;
`;

export const TotalCountNumber = styled.span`
  font-style: bold;
`;

export const ItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: calc(var(--full-width) - 60px);
  margin: auto;
  gap: 25px;

  @media ${(props) => props.theme.device.tabletL} {
    padding: 0 20px;
    justify-content: center;
  }
`;

export const InfoContainer = styled.div.attrs(() => ({
  className: 'info-container',
}))`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
  background-color: ${(props) => props.theme.colors.transparent};

  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
    padding: 0px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    //padding-right: 20px;
    margin-bottom: 15px;
  }

  .state {
    width: auto;
    height: 22px;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    text-align: center;
    color: ${(props) => props.theme.colors.darkerGrey};
    text-transform: uppercase;
    padding: 2px 5px;

    @media ${(props) => props.theme.device.tabletL} {
      display: none;
    }
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-right: 15px;
`;

export const SearchContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 52px 60px;
  background-color: ${(props) => props.theme.colors.transparent};
`;

export const PageWrapper = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;
